import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import type { IcmLineItem } from "@/icm/types";

const CustomerCol = (): ColumnDef<IcmLineItem> => ({
  accessorKey: "customer_name",
  header: "Customer",
  meta: { size: "160px" },
  cell: ({ getValue }) => {
    const value = (getValue() as string | null) ?? "–";
    return (
      <LineClampedTooltip className="wrap-break-word">
        {value}
      </LineClampedTooltip>
    );
  },
});

export default CustomerCol;
